import { Component, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, OverlayComponent, TextareaComponent } from '@agilox/ui';

@Component({
	selector: 'ai-chat-downvote-overlay',
	imports: [TranslatePipe, OverlayComponent, TextareaComponent, ButtonComponent],
	templateUrl: './ai-chat-downvote-overlay.component.html',
})
export class AiChatDownvoteOverlayComponent {
	submitDownvote = output<string | undefined>();
	cancelled = output<void>();

	downvoteComment = signal<string>('');

	onSubmitFeedback(): void {
		this.submitDownvote.emit(this.downvoteComment().trim() || undefined);
	}

	onCancel(): void {
		this.cancelled.emit();
	}
}
